import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import Logo from '../../components/Logo_v2';

const Brand = ({ asideStatus, setAsideStatus, asideSubStatus, setAsideSubStatus, hasLogo = true }) => {
	return (
		<div className='brand'>
			{hasLogo && (
				<div className='brand-logo'>
					<h1 className='brand-title'>
						<Logo height={60} />
					</h1>
				</div>
			)}
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				onClick={() => {
					setAsideStatus(!asideStatus);
					setAsideSubStatus(!asideSubStatus);
				}}>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
